import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTabsModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule
} from 'devextreme-angular';

// module imports
import { ManagementCommonModule } from '../management-common/management-common.module';
import { SharedACCBoardApprovalModule } from '../shared-acc-board-approval-module/shared-acc-board-approval-module.module';
import { SharedModule } from '../shared-module/shared.module';
import { SharedWorkflowModule } from '../shared-workflow-module/shared-workflow.module';
import { WorkflowModule } from '../workflow/workflow.module';
import { BoardApprovalRoutingModule } from './board-approval-routing.module';

// component imports
import { BoardApprovalGridNotesEditorComponent } from './component/board-approval-grid-notes-editor/board-approval-grid-notes-editor.component';
import { BoardApprovalGridComponent } from './component/board-approval-grid/board-approval-grid.component';
import { BoardApprovalComponent } from './component/board-approval/board-approval.component';
import { MulipleBoardApprovalEditorComponent } from './component/muliple-board-approval-editor/muliple-board-approval-editor.component';

@NgModule({
    declarations: [
        BoardApprovalComponent,
        BoardApprovalGridComponent,
        MulipleBoardApprovalEditorComponent,
        BoardApprovalGridNotesEditorComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        DxLoadPanelModule,
        DxBoxModule,
        DxToolbarModule,
        DxTabsModule,
        DxRadioGroupModule,
        DxDateBoxModule,
        DxFormModule,
        DxDataGridModule,
        DxButtonModule,
        DxDropDownButtonModule,
        DxPopupModule,
        DxTextAreaModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        SharedModule,
        ManagementCommonModule,
        BoardApprovalRoutingModule,
        SharedACCBoardApprovalModule,
        SharedWorkflowModule,
        WorkflowModule
    ],
    exports: [BoardApprovalComponent],
    entryComponents: [BoardApprovalComponent]
})
export class BoardApprovalModule {}
